import React from 'react';
import styled from 'styled-components';
import DropdownMenu from './DropdownMenu';
import SearchBar from './SearchBar';
import { xs } from '../BreakPoints';
import ProfileBox from './ProfileBox';
import { useHistory } from 'react-router-dom';
import pephubLogo from '../Images/pephub-board.svg';

const Container = styled.div`
	height: 3.15rem;
	width: 100%;
	background: rgba(255, 255, 255, 0.95);
	border-bottom: 1px solid var(--line-mid);
	position: fixed;
	top: 0;
	left: 0;
	z-index: 100;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 0 0.78rem;
	gap: 0.5rem;
	${xs({
		padding: '0 0.6rem',
	})}
`;

const LeftSide = styled.div`
	flex: 1;
	height: 100%;
	display: flex;
	gap: 0.4rem;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	${xs({
		gap: '0.35rem',
		width: 'fit-content',
	})}
`;

const RightSide = styled.div`
	flex: 1;
	height: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	gap: 0.28rem;
`;

const LogoContainer = styled.div`
	display: flex;
	align-items: center;
	height: 100%;
`;

const BrandLogo = styled.img`
	width: auto;
	height: 35px;
	cursor: pointer;
	display: block;
`;

const DropdownContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	${xs({
		display: 'none',
	})}
`;

const Navbar = (props) => {
	const history = useHistory();

	return (
		<Container>
			<LeftSide>
				<LogoContainer>
					<BrandLogo
						onClick={() => {
							history.push('/boards');
						}}
						src={pephubLogo}
					/>
				</LogoContainer>
				<DropdownContainer>
					<DropdownMenu title='Your Boards' />
				</DropdownContainer>
			</LeftSide>
			<RightSide>
				<SearchBar
					searchString={props.searchString}
					setSearchString={props.setSearchString}
					placeholder={props.searchPlaceholder}
				/>
				<ProfileBox />
			</RightSide>
		</Container>
	);
};

export default Navbar;
